let _navigate = null;
export const setNavigate = (fn) => { _navigate = fn; };
export const navigateTo = (path, opts) => { if (_navigate) _navigate(path, opts); };
